import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_804c6bc2 from 'nuxt_plugin_plugin_804c6bc2' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_wmIcons_fe06e642 from 'nuxt_plugin_wmIcons_fe06e642' // Source: ./wmIcons.js (mode: 'all')
import nuxt_plugin_nuxtplugin3e6dd342_407a4ce4 from 'nuxt_plugin_nuxtplugin3e6dd342_407a4ce4' // Source: ./nuxt.plugin.3e6dd342.js (mode: 'server')
import nuxt_plugin_image_76fa2908 from 'nuxt_plugin_image_76fa2908' // Source: ./image.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_05b511b5 from 'nuxt_plugin_cookieuniversalnuxt_05b511b5' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_8b0d8464 from 'nuxt_plugin_pluginutils_8b0d8464' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginseo_ed2b66bc from 'nuxt_plugin_pluginseo_ed2b66bc' // Source: ./nuxt-i18n/plugin.seo.js (mode: 'all')
import nuxt_plugin_pluginrouting_91bce0ce from 'nuxt_plugin_pluginrouting_91bce0ce' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_5f6e2a76 from 'nuxt_plugin_pluginmain_5f6e2a76' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_runtimeplugina98c837a_3fd40c69 from 'nuxt_plugin_runtimeplugina98c837a_3fd40c69' // Source: ./runtime.plugin.a98c837a.mjs (mode: 'all')
import nuxt_plugin_partfinderplugin2a65ce95_28b17280 from 'nuxt_plugin_partfinderplugin2a65ce95_28b17280' // Source: ./part-finder.plugin.2a65ce95.ts (mode: 'all')
import nuxt_plugin_customerplugin_672e1b20 from 'nuxt_plugin_customerplugin_672e1b20' // Source: ./customer.plugin.js (mode: 'all')
import nuxt_plugin_runtimeplugind3fc918e_827de6dc from 'nuxt_plugin_runtimeplugind3fc918e_827de6dc' // Source: ./runtime.plugin.d3fc918e.mjs (mode: 'all')
import nuxt_plugin_portalvue_01da4066 from 'nuxt_plugin_portalvue_01da4066' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_gtmpluginclient_3bb266aa from 'nuxt_plugin_gtmpluginclient_3bb266aa' // Source: ./gtm.plugin.client.js (mode: 'client')
import nuxt_plugin_paymentSveaPlugin_bcbbfb6a from 'nuxt_plugin_paymentSveaPlugin_bcbbfb6a' // Source: ./paymentSveaPlugin.js (mode: 'all')
import nuxt_plugin_postscribeclient_2431a558 from 'nuxt_plugin_postscribeclient_2431a558' // Source: ./postscribe.client.js (mode: 'client')
import nuxt_plugin_runtimeplugin222b0d22_4be21ba5 from 'nuxt_plugin_runtimeplugin222b0d22_4be21ba5' // Source: ./runtime.plugin.222b0d22.mjs (mode: 'all')
import nuxt_plugin_runtimeplugin8403ab56_00562602 from 'nuxt_plugin_runtimeplugin8403ab56_00562602' // Source: ./runtime.plugin.8403ab56.mjs (mode: 'all')
import nuxt_plugin_runtimeplugin05616d6e_37bae644 from 'nuxt_plugin_runtimeplugin05616d6e_37bae644' // Source: ./runtime.plugin.05616d6e.mjs (mode: 'all')
import nuxt_plugin_gtm_02f99223 from 'nuxt_plugin_gtm_02f99223' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_distpluginaf5e277a_4db765ab from 'nuxt_plugin_distpluginaf5e277a_4db765ab' // Source: ./dist.plugin.af5e277a.mjs (mode: 'all')
import nuxt_plugin_pluginsfcb16eed44_3be7301c from 'nuxt_plugin_pluginsfcb16eed44_3be7301c' // Source: ./plugins.fc.b16eed44.mjs (mode: 'all')
import nuxt_plugin_coreplugin02b39460_0c28c8a6 from 'nuxt_plugin_coreplugin02b39460_0c28c8a6' // Source: ./core.plugin.02b39460.ts (mode: 'all')
import nuxt_plugin_pluginstokenexpireda953fa76_51c20e06 from 'nuxt_plugin_pluginstokenexpireda953fa76_51c20e06' // Source: ./plugins.token-expired.a953fa76.ts (mode: 'all')
import nuxt_plugin_pluginsdompurify4b84ea05_445ae60b from 'nuxt_plugin_pluginsdompurify4b84ea05_445ae60b' // Source: ./plugins.dompurify.4b84ea05.ts (mode: 'all')
import nuxt_plugin_pluginsi18n1db2a5a6_a02808aa from 'nuxt_plugin_pluginsi18n1db2a5a6_a02808aa' // Source: ./plugins.i18n.1db2a5a6.ts (mode: 'all')
import nuxt_plugin_pluginsfixLocaleRoutes98a52046_147da6aa from 'nuxt_plugin_pluginsfixLocaleRoutes98a52046_147da6aa' // Source: ./plugins.fixLocaleRoutes.98a52046.ts (mode: 'all')
import nuxt_plugin_pluginse2etesting2c073740_d7ecbf9c from 'nuxt_plugin_pluginse2etesting2c073740_d7ecbf9c' // Source: ./plugins.e2e-testing.2c073740.js (mode: 'all')
import nuxt_plugin_deviceplugin_48186698 from 'nuxt_plugin_deviceplugin_48186698' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_workbox_44ae5c2e from 'nuxt_plugin_workbox_44ae5c2e' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_47ea1ffc from 'nuxt_plugin_metaplugin_47ea1ffc' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_4c91c570 from 'nuxt_plugin_iconplugin_4c91c570' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_bodyattrs_605d2e2a from 'nuxt_plugin_bodyattrs_605d2e2a' // Source: ../plugins/body-attrs.js (mode: 'client')
import nuxt_plugin_storeConfigPlugin_cbd09bc6 from 'nuxt_plugin_storeConfigPlugin_cbd09bc6' // Source: ../node_modules/@wemade-vsf/core/lib/runtime/plugins/storeConfigPlugin.mjs (mode: 'server')
import nuxt_plugin_vClickOutside_3a1129fa from 'nuxt_plugin_vClickOutside_3a1129fa' // Source: ../plugins/vClickOutside.js (mode: 'client')
import nuxt_plugin_meta_439ba0f1 from 'nuxt_plugin_meta_439ba0f1' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const store = null
  const router = await createRouter(ssrContext, config, { store })

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Agrideler","titleTemplate":"%s - Agrideler","meta":[{"charset":"utf8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0"},{"hid":"description","name":"description","content":""},{"hid":"og:site_name","property":"og:site_name","name":"og:site_name","content":"Agrideler"},{"hid":"og:title","name":"og:title","property":"og:title","content":"","template":(chunk) => chunk ? `${chunk} - Agrideler` : 'Agrideler'},{"hid":"og:description","property":"og:description","content":""},{"hid":"apple-mobile-web-app-title","property":"apple-mobile-web-app-title","content":"Agrideler"},{"name":"og:image","hid":"og:image","property":"og:image","content":"\u002Fogimage.jpg"},{"name":"google-site-verification","hid":"google-site-verification","content":"_PhM5y0IuzvcSagNdWcafptU1mcW2Iw6PzuFZbd1PJE"},{"name":"generator","content":"Vue Storefront 2"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.googleapis.com"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com","crossorigin":true},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Poppins:wght@400;600;700&display=swap"}],"bodyAttrs":{"id":"html-body"},"style":[],"script":[{"hid":"gtm-consent","innerHTML":"window.dataLayer = window.dataLayer || [];\n  dataLayer.push(['consent', 'default', {\n    ad_personalization: \"denied\",\n    ad_storage: \"denied\",\n    ad_user_data: \"denied\",\n    analytics_storage: \"denied\",\n    functionality_storage: \"denied\",\n    personalization_storage: \"denied\",\n    security_storage: \"granted\",\n    wait_for_update: 500\n  }]);\n  dataLayer.push(['set', 'ads_data_redaction', true]);\n  dataLayer.push(['set', 'url_passthrough', true]);","data-cookieconsent":"ignore"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-T5JHK2LM')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-T5JHK2LM&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"],"gtm-consent":["innerHTML"]}},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_804c6bc2 === 'function') {
    await nuxt_plugin_plugin_804c6bc2(app.context, inject)
  }

  if (typeof nuxt_plugin_wmIcons_fe06e642 === 'function') {
    await nuxt_plugin_wmIcons_fe06e642(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_nuxtplugin3e6dd342_407a4ce4 === 'function') {
    await nuxt_plugin_nuxtplugin3e6dd342_407a4ce4(app.context, inject)
  }

  if (typeof nuxt_plugin_image_76fa2908 === 'function') {
    await nuxt_plugin_image_76fa2908(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_05b511b5 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_05b511b5(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_8b0d8464 === 'function') {
    await nuxt_plugin_pluginutils_8b0d8464(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginseo_ed2b66bc === 'function') {
    await nuxt_plugin_pluginseo_ed2b66bc(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_91bce0ce === 'function') {
    await nuxt_plugin_pluginrouting_91bce0ce(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_5f6e2a76 === 'function') {
    await nuxt_plugin_pluginmain_5f6e2a76(app.context, inject)
  }

  if (typeof nuxt_plugin_runtimeplugina98c837a_3fd40c69 === 'function') {
    await nuxt_plugin_runtimeplugina98c837a_3fd40c69(app.context, inject)
  }

  if (typeof nuxt_plugin_partfinderplugin2a65ce95_28b17280 === 'function') {
    await nuxt_plugin_partfinderplugin2a65ce95_28b17280(app.context, inject)
  }

  if (typeof nuxt_plugin_customerplugin_672e1b20 === 'function') {
    await nuxt_plugin_customerplugin_672e1b20(app.context, inject)
  }

  if (typeof nuxt_plugin_runtimeplugind3fc918e_827de6dc === 'function') {
    await nuxt_plugin_runtimeplugind3fc918e_827de6dc(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_01da4066 === 'function') {
    await nuxt_plugin_portalvue_01da4066(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtmpluginclient_3bb266aa === 'function') {
    await nuxt_plugin_gtmpluginclient_3bb266aa(app.context, inject)
  }

  if (typeof nuxt_plugin_paymentSveaPlugin_bcbbfb6a === 'function') {
    await nuxt_plugin_paymentSveaPlugin_bcbbfb6a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_postscribeclient_2431a558 === 'function') {
    await nuxt_plugin_postscribeclient_2431a558(app.context, inject)
  }

  if (typeof nuxt_plugin_runtimeplugin222b0d22_4be21ba5 === 'function') {
    await nuxt_plugin_runtimeplugin222b0d22_4be21ba5(app.context, inject)
  }

  if (typeof nuxt_plugin_runtimeplugin8403ab56_00562602 === 'function') {
    await nuxt_plugin_runtimeplugin8403ab56_00562602(app.context, inject)
  }

  if (typeof nuxt_plugin_runtimeplugin05616d6e_37bae644 === 'function') {
    await nuxt_plugin_runtimeplugin05616d6e_37bae644(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_02f99223 === 'function') {
    await nuxt_plugin_gtm_02f99223(app.context, inject)
  }

  if (typeof nuxt_plugin_distpluginaf5e277a_4db765ab === 'function') {
    await nuxt_plugin_distpluginaf5e277a_4db765ab(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsfcb16eed44_3be7301c === 'function') {
    await nuxt_plugin_pluginsfcb16eed44_3be7301c(app.context, inject)
  }

  if (typeof nuxt_plugin_coreplugin02b39460_0c28c8a6 === 'function') {
    await nuxt_plugin_coreplugin02b39460_0c28c8a6(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginstokenexpireda953fa76_51c20e06 === 'function') {
    await nuxt_plugin_pluginstokenexpireda953fa76_51c20e06(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsdompurify4b84ea05_445ae60b === 'function') {
    await nuxt_plugin_pluginsdompurify4b84ea05_445ae60b(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsi18n1db2a5a6_a02808aa === 'function') {
    await nuxt_plugin_pluginsi18n1db2a5a6_a02808aa(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsfixLocaleRoutes98a52046_147da6aa === 'function') {
    await nuxt_plugin_pluginsfixLocaleRoutes98a52046_147da6aa(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginse2etesting2c073740_d7ecbf9c === 'function') {
    await nuxt_plugin_pluginse2etesting2c073740_d7ecbf9c(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_48186698 === 'function') {
    await nuxt_plugin_deviceplugin_48186698(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_44ae5c2e === 'function') {
    await nuxt_plugin_workbox_44ae5c2e(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_47ea1ffc === 'function') {
    await nuxt_plugin_metaplugin_47ea1ffc(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_4c91c570 === 'function') {
    await nuxt_plugin_iconplugin_4c91c570(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bodyattrs_605d2e2a === 'function') {
    await nuxt_plugin_bodyattrs_605d2e2a(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_storeConfigPlugin_cbd09bc6 === 'function') {
    await nuxt_plugin_storeConfigPlugin_cbd09bc6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vClickOutside_3a1129fa === 'function') {
    await nuxt_plugin_vClickOutside_3a1129fa(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_439ba0f1 === 'function') {
    await nuxt_plugin_meta_439ba0f1(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
